import React, { useEffect } from 'react';
import Button from '../components/Button';
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import HaveProjects from '../components/HaveProjects';
import { Link } from 'react-router-dom';

gsap.registerPlugin(ScrollTrigger);


export default function AboutSection5() {
    useEffect(() => {
        // Only enable parallax on tablet/desktop; disable on phones
        const mm = gsap.matchMedia();
        mm.add("(min-width: 768px)", () => {
            const tween = gsap.to(".parallax-img", {
                y: -130,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: ".parallax-container",
                    start: "top bottom",
                    end: "bottom top",
                    scrub: 1.5,
                    invalidateOnRefresh: true,
                },
            });

            // Cleanup for this media query
            return () => {
                if (tween) tween.kill();
                if (tween && tween.scrollTrigger) tween.scrollTrigger.kill();
            };
        });

        // Revert matchMedia on unmount (runs the cleanup of matching queries)
        return () => {
            mm.revert();
        };
    }, []);
    return (
        <div className="xl:min-h-screen dark:bg-zinc-900 text-white relative overflow-hidden">

            {/* Main Content */}
            <div className="relative z-10 flex xl:min-h-screen">
                {/* Left Section */}
                <div className="flex-1 flex flex-col justify-center">
                    <div className="xl:px-35 px-10 py-15 relative parallax-container overflow-hidden mb-20">
                        <div className="h-[80vh] parallax-img w-full absolute top-0 left-0 z-[-1] overflow-hidden">
                            <img
                                src="/new-final-data/contact/Contact.webp"
                                alt=""
                                className="w-full h-full object-cover"
                            />
                        </div>

                        <div className="mb-2">
                            <span className="text-gray-400 text-sm tracking-wider uppercase">Contact</span>
                        </div>

                        <div className="flex justify-between flex-col xl:flex-row">
                            <div className="mb-12">
                                <h1 className="xl:text-5xl text-4xl font-bold leading-tight mb-8">
                                    Do you want to know <br />
                                    more <span className="">about us?</span>
                                </h1>

                                <Link to={"/contact"}>
                                    <Button style={{border: '1px solid rgba(255, 255, 255, 0.5) !important'}}>Get in touch</Button>
                                </Link>
                            </div>
                            {/* Address */}
                            <div
                                className="sm:text-left sm:max-w-[250px] ml-10 col-span-2 sm:col-span-1 text-center md:text-left"
                                
                            >
                                <h4 className="text-lg font-semibold raleway">USA</h4>
                                <p className="mt-2  raleway">
                                    <a href="">
                                        3422 Old Capitol Trail <br /> Wilmington DE 19808 , USA
                                    </a>
                                </p>
                                <p className="mt-2  raleway">+1 408-676-5986</p>
                                <h4 className="text-lg font-semibold raleway mt-5">India</h4>
                                <p className="mt-2  raleway">
                                    <a href="">
                                        B 73, Block B, Sector 57 <br /> Noida, Uttar Pradesh, India
                                    </a>
                                </p>
                                <p className="mt-2  raleway">+91 88262-88647</p>
                            </div>
                        </div>
                    </div>

                    <HaveProjects />
                </div>
            </div>

        </div>
    );
}